import React from 'react'
import { CobuText, CobuStack } from '@cobu/ui'

type ProfileMenuItemProps = {
  title: string
  onPress: () => void
  isFirstItem?: boolean
  isLastItem?: boolean
}

export default function ProfileMenuItem({ title, onPress, isFirstItem = false, isLastItem = false }: ProfileMenuItemProps) {
  return (
    <CobuStack
      layout="horizontal"
      py="$3"
      px="$4"
      ai="center"
      gap="$3"
      bg="$background"
      w="100%"
      minH="$11"
      style={{
        borderTopWidth: isFirstItem ? 0 : 1,
        borderBottomWidth: isLastItem ? 0 : 1,
        borderColor: 'rgba(0, 0, 0, 0.08)',
        borderStyle: 'solid',
        borderLeftWidth: 0,
        borderRightWidth: 0,
        cursor: 'pointer',
      }}
      onPress={onPress}
      role="button"
      tabIndex={0}
    >
      <CobuText variant="body" f={1} color="$cobuDarkBlue" fontWeight="regular" fontSize={'$3' as any}>
        {title}
      </CobuText>
      <CobuText color="$lightBlueGray" fontSize={20 as any}>{'›'}</CobuText>
    </CobuStack>
  )
}


